
// Rutas estáticas mínimas
export default [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/login-test",
    component: () => import("@/views/loginTest/LoginTest.vue")
  },
  {
    // Always leave this as last one
    path: "*",
    component: () => import("@/views/404/404.vue")
  }
];
